<template>
  <q-expansion-item
    ref="expansionItem"
    :to="route"
    class="text-sm"
    expand-icon="sym_r_expand_more"
    expanded-icon="sym_r_expand_less"
    tag="a"
    clickable
    expand-icon-toggle
    @click="toggleExpansionItem"
  >
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="slotProps"
    >
      <slot v-if="slotProps" v-bind="slotProps" :name="slot"></slot>
      <slot v-else :name="slot"></slot>
    </template>

    <template #header>
      <q-item-section v-if="icon" class="no-wrap items-center q-pr-xxs" side>
        <q-icon>
          <component :is="icon" class="icon--sm" data-testid="icon"></component>
        </q-icon>
      </q-item-section>
      <q-item-section>
        <span :title="title" class="ellipsis full-width">{{ title }}</span>
      </q-item-section>
    </template>
  </q-expansion-item>
</template>

<script setup>
import { ENTRY_POINT } from "src/assets/scripts/utilities/constants";

const props = defineProps({
  icon: {
    type: Object,
    default: () => {
      return null;
    },
  },
  route: {
    type: Object,
    default: () => {
      return ENTRY_POINT;
    },
  },
  subItems: {
    type: Array,
    default: () => {
      return [];
    },
  },
  title: {
    type: String,
    required: true,
  },
});

const expansionItem = ref(null);

const toggleExpansionItem = () => {
  if (props.subItems.length) {
    unref(expansionItem).toggle();
  }
};
</script>

<style lang="scss" scoped>
:deep(.q-focus-helper) {
  display: none;
}

.q-expansion-item {
  :deep(.q-expansion-item__container) {
    &::before,
    &::after {
      transition:
        height 0.3s 0s linear,
        opacity 0.3s 0s linear;

      background-color: transparent;
      border-radius: 25px;

      content: "";

      opacity: 0;

      position: absolute;
      right: 0;
    }

    .q-item {
      border-radius: 8px;
      min-height: 32px;
      padding: 10px 16px;
      z-index: 1;

      &.disabled {
        opacity: 1 !important;
        .q-item__section {
          color: $neutral-50;
        }
      }

      &:not(.active, .disabled):hover {
        .q-item__section {
          color: $primary;
        }
      }

      .q-item__section {
        color: $neutral;
      }
    }

    .q-expansion-item__toggle-icon {
      margin-top: 0;
    }
  }

  &[active="true"] {
    & > :deep(.q-expansion-item__container) {
      & > a.q-item {
        background-image: url("src/assets/icons/nav-item-bg.svg");
        background-attachment: fixed;
        background-origin: border-box;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;

        &:hover {
          .q-item__section {
            color: $primary;
          }
        }

        .q-item__section {
          color: $primary;
          font-weight: 500;
        }

        z-index: 1;
      }
    }
  }

  :deep(.q-expansion-item__toggle-icon) {
    font-size: 18px;
  }
}
</style>
